export class StringUtil {

  static removeNonNumber(input: string): string {
    return input.replace(/\D/g, "");
  }

  static removeSpecialCharacters(nome: string) {
    nome = nome.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    return nome;
  }

  static extractParamUrl(url: string, param: string): string | null {
      return new URLSearchParams(url).get(param);
  }

  static formatValor(valor: number): string {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(valor);
  }

}
